<template>
  <v-slide-y-reverse-transition>
    <v-menu
      offset-y
      max-width="25%"
      min-width="350"
      max-height="300"
      :close-on-content-click="false"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-badge
          :content="messages.length > 9 ? '+9' : messages.length"
          :value="messages.length > 9 ? '+9' : messages.length"
          color="indigo darken-4"
          offset-x="30"
          offset-y="21"
          dark
        >
          <v-btn
            color="blue"
            class="mx-2"
            small
            text
            fab
            v-bind="attrs"
            v-on="on"
          >
            <v-icon>mdi-{{ active ? "bell-badge" : "bell-outline" }}</v-icon>
          </v-btn>
        </v-badge>
      </template>
      <v-row>
        <v-col cols="auto" class="mx-3 grey--text">
          <h4>Notifications</h4>
        </v-col>
        <v-spacer> </v-spacer>
        <v-col cols="auto" v-if="active">
          <v-btn x-small color="info" text plain @click="clear">
            <v-icon x-small>mdi-delete-empty</v-icon> clear all
          </v-btn>
        </v-col>
      </v-row>
      <v-divider></v-divider>
      <section class="scrollable hm25">
        <v-list color="grey lighten-5">
          <template>
            <v-list-item v-for="msg in messages" :key="msg.id" dense>
              <v-list-item-action class="mr-1">
                <v-btn icon x-small @click="dismiss(msg.id)">
                  <v-icon x-small color="error lighten-1">mdi-delete</v-icon>
                </v-btn>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title v-html="msg.content"> </v-list-item-title>
                <v-list-item-subtitle
                  v-if="msg.ts"
                  class="grey--text"
                  v-html="relativeTime(msg.ts)"
                >
                </v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-icon v-if="msg.icon">
                <v-icon
                  :class="`${msg.color || msg.type} lighten-5 iconWrap`"
                  :color="msg.color || msg.type"
                  size="20"
                >
                  mdi-{{ msg.icon ? msg.icon : "information" }}
                </v-icon>
              </v-list-item-icon>
            </v-list-item>
          </template>
          <v-list-item v-if="!active">
            <v-list-item-content class="text-center">
              <v-list-item-subtitle class="grey--text">
                <v-icon color="grey lighten-2" class="mt-n1" small>
                  mdi-bell-off
                </v-icon>
                No Pending Notifications
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </section>
    </v-menu>
  </v-slide-y-reverse-transition>
</template>

<script lang="ts">
import moment from "moment";
import Vue from "vue";

export default Vue.extend({
  name: "NotificationsComp",
  data() {
    return { open: false };
  },
  methods: {
    dismiss(id: string) {
      return this.$store.commit("rmNotification", id);
    },
    clear() {
      return this.$store.commit("rmAllNotification");
    },
    toggle() {
      this.open = !this.open;
      console.log("toggle", this.open);
    },
    close() {
      this.$emit("close");
    },
    relativeTime(ts: number): string {
      return moment(ts).fromNow();
    },
  },
  computed: {
    active() {
      return this.messages.length > 0;
    },
    messages() {
      return this.$store.getters.getNotifications;
    },
  },
});
</script>
<style scoped>
.v-menu__content {
  /* position: absolute;
  z-index: 9999; */
  background-color: #fff !important;
}
</style>
